import { variables } from '@bitrise/bitkit';
import Bezier from 'bezier-easing';
import { Transition } from 'framer-motion';

const transition: Transition = {
  duration: variables.transitionDurationFast / 1000,
  ease: Bezier(0.25, 0.46, 0.45, 0.94),
  type: 'tween',
};

export default transition;
